import React, { useState } from 'react'
import { Row, Button } from 'reactstrap'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'

import { setCampaignData, getCampaigns } from 'redux/actions/marketing'
import { marketing } from 'api'
import ModalDelete from 'components/ModalDelete'

const DISPLAY_COMPONENT = ['DRAFT', 'SCHEDULED']
const DISPLAY_BTN_EDIT = ['DRAFT', 'SCHEDULED']
const DISPLAY_BTN_REMOVE = ['DRAFT', 'SCHEDULED']

/**
 * CampaignDetailButtons
 * @param {object} props
 * @param {string} props.state
 * @param {object} props.campaign
 */
function CampaignDetailButtons(props) {
  const { state, campaign } = props

  const [openRemoveModal, setOpenRemoveModal] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()

  if (!DISPLAY_COMPONENT.includes(state)) return null

  const onOpenRemoveModal = () => {
    setOpenRemoveModal(true)
  }

  const onEdit = () => {
    dispatch(setCampaignData(campaign))
    history.push('/dashboard/marketing/create/campaigns')
  }

  const onRemove = async () => {
    setDisabled(true)

    try {
      await marketing.deleteCampaign(campaign._id)
      dispatch(getCampaigns())
      history.push('/dashboard/marketing/campaigns')
    } catch(error) {
      toast(I18n.t(error.data.type || 'toasts_generic_error'), { autoClose: 4000 })

      setDisabled(false)
    }
  }

  return (
    <Row className='d-flex justify-content-between mt-3'>
      {
        DISPLAY_BTN_EDIT.includes(state)
          ? <Button onClick={onEdit}>{I18n.t('dashboard_edit')}</Button>
          : null
      }
      {
        DISPLAY_BTN_REMOVE.includes(state)
          ? (
            <div>
              <Button onClick={onOpenRemoveModal} size='sm' color='danger' >{I18n.t('dashboard_delete')}</Button>
              <ModalDelete
                isOpen={openRemoveModal}
                toggle={() => setOpenRemoveModal(!openRemoveModal)}
                className='vc-modal-remove'
                header={I18n.t('campaign_remove')}
                text1={I18n.t('campaign_remove_title')}
                text2={I18n.t('dashboard_action-cannot-reversed')}
                event={onRemove}
                isSubmitting={disabled}
              />
            </div>
          )
          : null
      }
    </Row>

  )
}

export default CampaignDetailButtons
